import React from 'react';
import PropTypes from 'prop-types';
import {Button, Icon} from 'semantic-ui-react';

import config from 'config';
import {IncludeScript, Loading} from 'Common/Structure';

import './authForm.scss';

class AuthForm extends React.Component {
  state = {
    authButtonVisible: false,
    errorText: null,
  };

  componentDidMount() {
    window.authNetResponseHandler = this.responseHandler;

    setTimeout(() => {
      this.setState({authButtonVisible: true});
    }, 3000);
  }

  responseHandler = response => {
    if (response.messages.resultCode === 'Error') {
      this.setState({errorText: response.messages.message[0].text});
      response.messages.message.forEach(m =>
        console.log(`${m.code}: ${m.text}`),
      );
    } else {
      const {encryptedCardData: cardData, opaqueData} = response;
      const json = {
        dataDescriptor: opaqueData.dataDescriptor,
        dataValue: opaqueData.dataValue,
        lastFourDigits: cardData.cardNumber.substring(
          cardData.cardNumber.length - 4,
        ),
        expiration: cardData.expDate,
        cardIdentifier: cardData.bin,
      };

      this.props.setProcessor(json);
    }
  };

  render() {
    return (
      <IncludeScript id="auth-js" src={config.authScriptUrl}>
        <div id="authForm" style={{textAlign: 'center'}}>
          <Button
            basic={this.props.auth !== null}
            className="AcceptUI"
            data-acceptuiformbtntxt="Submit"
            data-acceptuiformheadertxt="Card Information"
            data-apiloginid={this.props.loginKey}
            data-billingaddressoptions="{&quot;show&quot;: false, &quot;required&quot;: false}"
            data-clientkey={this.props.clientKey}
            data-responsehandler="authNetResponseHandler"
            primary
            style={this.state.authButtonVisible ? {} : {display: 'none'}}
            type="button"
          >
            Enter Credit Card{' '}
            {this.props.auth && <Icon name="check" style={{marginLeft: 5}} />}
          </Button>

          {!this.state.authButtonVisible && <Loading inline />}

          {this.state.errorText && (
            <div id="errors">{this.state.errorText}</div>
          )}
        </div>
      </IncludeScript>
    );
  }
}

AuthForm.propTypes = {
  auth: PropTypes.object,
  clientKey: PropTypes.string.isRequired,
  loginKey: PropTypes.string.isRequired,

  // functions
  setProcessor: PropTypes.func.isRequired,
};

export default AuthForm;



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/PaymentForm/AuthForm/index.js